import { ClientConfigProductName } from '@frontend/vanilla/core';

export const PriceBoostLoader = {
    id: 'price-boost',
    loaderFn: () => import(/* webpackChunkName: "ms-price-boost" */ './price-boost.feature'),
    product: ClientConfigProductName.SPORTS,
};
